export default __webpack_public_path__ + "static/media/2021 cutlery top.454957d4.png";